import { ParallaxProvider, Parallax } from "react-scroll-parallax";
// import NMVpic from "../../images/NMV.svg";

const NMV = () => {
  return (
    <div className="color-dk-r">
      <div className="row m-0 flex-row-reverse">
        <div className="stickyRowHeaders col-lg-6 col-12 d-flex align-items-center justify-content-center  bg-color-gr">
          <div className="d-lg-none d-inline">
            <div>NMV Growth</div>
          </div>
          <div className="d-none d-lg-block">
            <ParallaxProvider>
              <Parallax
                translateY={[-100, 100]}
                opacity={[1, 0.8]}
                easing="easeOut"
                scale={[0.8, 1]}
              >
                <div>NMV Growth</div>
              </Parallax>
            </ParallaxProvider>
          </div>
        </div>

        <div className="col-lg-6 col-12 text-start color-dk-dark line-height-lg bg-color-w p-4 p-lg-5">
          <div className="p-0 p-lg-5">
            {/* <div>
              <h3 className="color-dk-gray mb-3 dk-semi-bold">
                Digikala’s
                <span className="color-dk-r"> NMV </span>
                in 2021-22 has
                <span className="color-dk-r"> grown 49% </span>
                compared with the year before.
              </h3>
            </div> */}
            <svg
              version="1.1"
              id="Layer_1"
              x="0px"
              y="0px"
              viewBox="0 0 324 313"
              // style="enable-background:new 0 0 324 313;"
              space="preserve"
            >
              <style type="text/css"></style>
              <line
                className="NMVst0"
                x1="13.4"
                y1="291.4"
                x2="313.2"
                y2="291.4"
              />
              <line
                className="NMVst1"
                x1="13.9"
                y1="252.7"
                x2="310.3"
                y2="8.1"
              />
              <polygon
                className="NMVst2"
                points="307.5,5.4 312.4,11.4 313.2,5.8 "
              />
              <line
                className="NMVst0"
                x1="78.5"
                y1="294.7"
                x2="78.5"
                y2="291.3"
              />
              <line
                className="NMVst0"
                x1="50.6"
                y1="294.7"
                x2="50.6"
                y2="291.3"
              />
              <line
                className="NMVst0"
                x1="22.6"
                y1="294.7"
                x2="22.6"
                y2="291.3"
              />
              <line
                className="NMVst0"
                x1="106.4"
                y1="294.7"
                x2="106.4"
                y2="291.3"
              />
              <line
                className="NMVst0"
                x1="134.4"
                y1="294.7"
                x2="134.4"
                y2="291.3"
              />
              <line
                className="NMVst0"
                x1="162.5"
                y1="294.7"
                x2="162.5"
                y2="291.3"
              />
              <line
                className="NMVst0"
                x1="190.5"
                y1="294.7"
                x2="190.5"
                y2="291.3"
              />
              <line
                className="NMVst0"
                x1="218.5"
                y1="294.7"
                x2="218.5"
                y2="291.3"
              />
              <line
                className="NMVst0"
                x1="246.5"
                y1="294.7"
                x2="246.5"
                y2="291.3"
              />
              <line
                className="NMVst0"
                x1="302.5"
                y1="294.7"
                x2="302.5"
                y2="291.3"
              />
              <text
                transform="matrix(1 0 0 1 290.7684 308.126)"
                className="NMVst3 NMVst4 NMVst5"
              >
                2021-22
              </text>
              <text
                transform="matrix(1 0 0 1 207.2728 308.126)"
                className="NMVst3 NMVst4 NMVst5"
              >
                2018-19
              </text>
              <line
                className="NMVst0"
                x1="274.6"
                y1="294.7"
                x2="274.6"
                y2="291.3"
              />
              <text
                transform="matrix(1 0 0 1 262.5482 308.126)"
                className="NMVst3 NMVst4 NMVst5"
              >
                2020-21
              </text>
              <text
                transform="matrix(1 0 0 1 179.3045 308.126)"
                className="NMVst3 NMVst4 NMVst5"
              >
                2017-18
              </text>
              <text
                transform="matrix(1 0 0 1 234.6111 308.126)"
                className="NMVst3 NMVst4 NMVst5"
              >
                2019-20
              </text>
              <text
                transform="matrix(1 0 0 1 151.3045 308.126)"
                className="NMVst3 NMVst4 NMVst5"
              >
                2016-17
              </text>
              <text
                transform="matrix(1 0 0 1 123.2693 308.126)"
                className="NMVst3 NMVst4 NMVst5"
              >
                2015-16
              </text>
              <text
                transform="matrix(1 0 0 1 95.2132 308.126)"
                className="NMVst3 NMVst4 NMVst5"
              >
                2014-15
              </text>
              <text
                transform="matrix(1 0 0 1 67.0872 308.126)"
                className="NMVst3 NMVst4 NMVst5"
              >
                2013-14
              </text>
              <text
                transform="matrix(1 0 0 1 39.2132 308.126)"
                className="NMVst3 NMVst4 NMVst5"
              >
                2012-13
              </text>
              <text
                transform="matrix(1 0 0 1 11.7874 308.126)"
                className="NMVst3 NMVst4 NMVst5"
              >
                2011-12
              </text>
              <g>
                <defs>
                  <rect
                    id="SVGID_1_"
                    x="-0.3"
                    y="5.4"
                    width="324.7"
                    height="307.1"
                  />
                </defs>
                <clipPath id="SVGID_00000176006246492762759280000006289212646774864774_">
                  <use href="#SVGID_1_" style={{ overflow: "visible" }} />
                </clipPath>
                <path
                  className="NMVbars"
                  // style="clip-path:url(#SVGID_00000176006246492762759280000006289212646774864774_);fill:#52C6D8;"
                  d="M67.5,284.6
		c0-1,0.8-1.8,1.8-1.8h18.5c1,0,1.8,0.8,1.8,1.8H67.5z"
                />
                <path
                  className="NMVbars"
                  // style="clip-path:url(#SVGID_00000176006246492762759280000006289212646774864774_);fill:#52C6D8;"
                  d="M39.5,284.6
		c0-0.6,0.5-1.2,1.2-1.2h19.7c0.6,0,1.2,0.5,1.2,1.2H39.5z"
                />
                <path
                  className="NMVbars"
                  // style="clip-path:url(#SVGID_00000176006246492762759280000006289212646774864774_);fill:#52C6D8;"
                  d="M11.6,284.6
		c0-0.6,0.5-1.2,1.2-1.2h19.7c0.6,0,1.2,0.5,1.2,1.2H11.6z"
                />
                <path
                  className="NMVbars"
                  // style="clip-path:url(#SVGID_00000176006246492762759280000006289212646774864774_);fill:#52C6D8;"
                  d="M95.4,283.4
		c0-1.3,1.1-2.4,2.4-2.4h17.2c1.3,0,2.4,1.1,2.4,2.4v1.2h-22V283.4z"
                />
                <path
                  className="NMVbars"
                  // style="clip-path:url(#SVGID_00000176006246492762759280000006289212646774864774_);fill:#52C6D8;"
                  d="M123.4,281.7
		c0-2.3,1.9-4.3,4.3-4.3h13.5c2.3,0,4.3,1.9,4.3,4.3v2.9h-22V281.7z"
                />
                <path
                  className="NMVbars"
                  // style="clip-path:url(#SVGID_00000176006246492762759280000006289212646774864774_);fill:#52C6D8;"
                  d="M151.4,276.6
		c0-2.3,1.9-4.3,4.3-4.3h13.5c2.3,0,4.3,1.9,4.3,4.3v8h-22V276.6z"
                />
                <path
                  className="NMVbars"
                  // style="clip-path:url(#SVGID_00000176006246492762759280000006289212646774864774_);fill:#52C6D8;"
                  d="M179.3,270.8
		c0-2.3,1.9-4.3,4.3-4.3h13.5c2.3,0,4.3,1.9,4.3,4.3v13.8h-22V270.8z"
                />
                <path
                  className="NMVbars"
                  // style="clip-path:url(#SVGID_00000176006246492762759280000006289212646774864774_);fill:#52C6D8;"
                  d="M207.3,262.8
		c0-2.3,1.9-4.3,4.3-4.3h13.5c2.3,0,4.3,1.9,4.3,4.3v21.8h-22V262.8z"
                />
                <path
                  className="NMVbars"
                  // style="clip-path:url(#SVGID_00000176006246492762759280000006289212646774864774_);fill:#52C6D8;"
                  d="M235.2,225.1
		c0-2.3,1.9-4.3,4.3-4.3H253c2.3,0,4.3,1.9,4.3,4.3v59.6h-22V225.1z"
                />
                <path
                  className="NMVbars"
                  // style="clip-path:url(#SVGID_00000176006246492762759280000006289212646774864774_);fill:#52C6D8;"
                  d="M263.5,131.4
		c0-2.3,1.9-4.3,4.3-4.3h13.5c2.3,0,4.3,1.9,4.3,4.3v153.2h-22V131.4z"
                />
                <path
                  className="NMVbars"
                  // style="clip-path:url(#SVGID_00000176006246492762759280000006289212646774864774_);fill:#52C6D8;"
                  d="M291.1,54.6
		c0-2.3,1.9-4.3,4.3-4.3h13.5c2.3,0,4.3,1.9,4.3,4.3v230.1h-22V54.6z"
                />
              </g>
              <text
                transform="matrix(1 0 0 1 127.4276 95.3253)"
                className="NMVst2 NMVst7 NMVst8"
              >
                94%
              </text>
              <text
                transform="matrix(1 0 0 1 102.7122 114.9258)"
                className="NMVst3 NMVst9 NMVst10"
              >
                {" "}
              </text>
              <text
                transform="matrix(1 0 0 1 98.8323 107.9258)"
                className="NMVst3 NMVst4 NMVst11"
              >
                Average Annual
              </text>
              <text
                transform="matrix(1 0 0 1 108.7762 117.5255)"
                className="NMVst3 NMVst4 NMVst11"
              >
                Growth Rate
              </text>
              <text
                transform="matrix(1 0 0 1 252.4671 95.4415)"
                className="NMVst2 NMVst7 NMVst8"
              >
                49%
              </text>
              <text
                transform="matrix(1 0 0 1 216.7679 108.0421)"
                className="NMVst3 NMVst9 NMVst10"
              >
                {" "}
              </text>
              <text
                transform="matrix(1 0 0 1 204.8875 108.0421)"
                className="NMVst3 NMVst4 NMVst12"
              >
                Growth Compared
              </text>
              <text
                transform="matrix(1 0 0 1 212.3836 117.6417)"
                className="NMVst3 NMVst4 NMVst12"
              >
                to Previous Year
              </text>
              <g>
                <defs>
                  <rect
                    id="SVGID_00000045601603935719790490000007164728981929866408_"
                    x="-0.3"
                    y="5.4"
                    width="324.7"
                    height="307.1"
                  />
                </defs>
                <clipPath id="SVGID_00000082336019954120459510000008890622004559152793_">
                  <use
                    href="#SVGID_00000045601603935719790490000007164728981929866408_"
                    // style="overflow:visible;"
                  />
                </clipPath>

                <path
                  className="NMVcurve"
                  // style="clip-path:url(#SVGID_00000082336019954120459510000008890622004559152793_);fill:none;stroke:#EF4056;stroke-linecap:round;"
                  d="
		M274.6,63.9c0,11.6-2.4,16.1-19.1,16.1"
                />
                <polygon
                  className="NMVcurveHead"
                  // style="clip-path:url(#SVGID_00000082336019954120459510000008890622004559152793_);fill:#EF4056;"
                  points="274.6,60.2 
		270.7,64.4 278.5,64.4 	"
                />
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NMV;
